var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 0C3.4635 0 0.333496 3.13 0.333496 7C0.333496 12.25 7.3335 20 7.3335 20C7.3335 20 14.3335 12.25 14.3335 7C14.3335 3.13 11.2035 0 7.3335 0ZM2.3335 7C2.3335 4.24 4.5735 2 7.3335 2C10.0935 2 12.3335 4.24 12.3335 7C12.3335 9.88 9.4535 14.19 7.3335 16.88C5.2535 14.21 2.3335 9.85 2.3335 7ZM7.3335 9.5C8.71421 9.5 9.8335 8.38071 9.8335 7C9.8335 5.61929 8.71421 4.5 7.3335 4.5C5.95278 4.5 4.8335 5.61929 4.8335 7C4.8335 8.38071 5.95278 9.5 7.3335 9.5Z",
    fill: "#0DAB01"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_pin.14ccf94da0ae8d5202899dc12c9f71cb.svg";